import React, { useState } from "react";
import OtpInput from "react-otp-input";
import Input from "sushiweb/InputTypes/Input"
import { PROFILE_INPUT_BORDER } from "../../../utils/constants/others";
import styles from "./CustomInputs.module.scss";

function OTPInput ({value , onChange,error ,onKeyDown, numericOnly = false}) {

  const handleChange = (next) => {
    if (!numericOnly) return onChange?.(next);
    const digitsOnly = (next ?? "").replace(/\D/g, "");
    onChange?.(digitsOnly);
  };

  const handleKeyDown = (e) => {
    if (numericOnly && e.key.length === 1 && !/\d/.test(e.key) && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
    }
    onKeyDown?.(e);
  };

  const handleBeforeInput = (e) => {
    if (numericOnly && e.data && /\D/.test(e.data)) e.preventDefault();
  };

  return (
    <div className="relative" onKeyDown={handleKeyDown} onBeforeInput={handleBeforeInput}>
                    <OtpInput
                       className={`${styles.otpInput}`}
                        value={value}
                        onChange={handleChange}
                        numInputs={6}
                        seperator = {"-"}
                        onKeyDown={handleKeyDown}
                    />
                    <div className="text-red mt-1 fs-14">{error}</div>
    </div>
  )
}

export default OTPInput;
